import { companyDisplayImageService } from '../../helpers/services/companyDisplayImage.service';
import i18n from '@/i18n'
import { sharedHelper, filtersHelper } from '@/utils'
import router from '@/router/index'

export const state = {
    list: {
        data: [],
        pagination: {
            pageNumber: 0,
            pageSize: 0,
            lastPage: 0,
            tableRowsCount: 0
        }
    },
    details: {},
    status: {}
}

export const DISPLAY_IMAGE_MODULE = 'companyDisplayImage';

// define action 
export const GET_ALL_DISPLAY_IMAGES = 'getAllDisplayImages';
export const CREATE_DISPLAY_IMAGE = 'createDisplayImage';
export const UPDATE_DISPLAY_IMAGE_STATUS = 'updateDisplayImageStatus';

// define mutation
const REQUESTING = "requesting";
const SUCCESS = "commonSuccess";
const SUCCESS_WITHOUT_REDIRECT = "successWithoutRedirect";
const FAILURE = "commonFailure";
const REQUEST = "commonRequest";
const GET_ALL_DISPLAY_IMAGES_REQUEST = "getAllDisplayImages";


export const actions = {
    // eslint-disable-next-line no-unused-vars
     [GET_ALL_DISPLAY_IMAGES]({ commit }, { filter }) {
         companyDisplayImageService
            .getAllDisplayImages(filter)
            .then(
                (result) => {
                    commit(GET_ALL_DISPLAY_IMAGES_REQUEST, result)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                }
            )
    },

    // eslint-disable-next-line no-unused-vars
    [CREATE_DISPLAY_IMAGE]({ commit }, { data }) {
        commit(REQUESTING);
        companyDisplayImageService
          .createDisplayImage(data)
          .then(
            // eslint-disable-next-line no-unused-vars
            (result) => {
              var message = i18n.t("message.createXSuccess", [i18n.t('module.companyDisplayImage')]);
              sharedHelper.alertSuccessMessage(message)
              commit(SUCCESS);
            },
            (error) => {
              let message = sharedHelper.getErrorMessage(error);
              sharedHelper.alertErrorMessage(message, error.response.data.code)
              commit(FAILURE);
            }
          )
      },

        // eslint-disable-next-line no-unused-vars
        [UPDATE_DISPLAY_IMAGE_STATUS]({ dispatch }, { filter, data }) {
            companyDisplayImageService
                .updateDisplayImage(data)
                .then(
                    // eslint-disable-next-line no-unused-vars  
                    (result) => {
                        var message = i18n.t('message.updateStatusSuccess');
                        sharedHelper.alertSuccessMessage(message)
                        dispatch(GET_ALL_DISPLAY_IMAGES, { filter })
                    },
                    (error) => {
                        let message = sharedHelper.getErrorMessage(error);
                        sharedHelper.alertErrorMessage(message, error.response.data.code)
                    }
                )
        }
};

export const mutations = {

    [SUCCESS](state) {
        state.status = {};
        router.push({ name: "Company-display-image" });
    },
    [SUCCESS_WITHOUT_REDIRECT](state) {
        state.status = {};
    },
    [FAILURE](state) {
        state.status = {};
    },
    [REQUEST](state) {
        state.status = { update: true, create: true };
    },
    [REQUESTING](state) {
        state.status = { processing: true };
    },

    [GET_ALL_DISPLAY_IMAGES_REQUEST](state, data) {
        let d = data.data
        state.list.pagination = sharedHelper.apiPaginationAdapter(data.pagination)

        state.list.data = d.map((o) => {
            return {
                uuid: o.uuid,
                company: o.company,
                isActive: o.is_active,
                createdBy: o.created_by,
                image: o.image,
                createdDateTime: filtersHelper.getDateFormat(o.created_date_time),
                updatedBy: o.updated_by,
                updatedDateTime: filtersHelper.getDateFormat(o.updated_date_time)
                
            }
        })
    },

}


